module.exports = __webpack_public_path__ + "static/media/摄图网_5.8c3f141b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_5.png
// module id = 1709
// module chunks = 0